<template>
  <v-checkbox
    class="pulse-checkbox"
    color="#6366f1"
    hide-details
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-if="$slots.label" #label><slot name="label" /></template>
  </v-checkbox>
</template>

<script>
export default {
  name: "PulseCheckbox",
  inheritAttrs: false,
};
</script>
